/**
 * @flow
 * @relayHash adb50cbd81284de07591885a050c5c3d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ProductsTable_project$ref = any;
export type ecommerce_ProductsTable_QueryVariables = {|
  host: string
|};
export type ecommerce_ProductsTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: ProductsTable_project$ref
  |}
|};
export type ecommerce_ProductsTable_Query = {|
  variables: ecommerce_ProductsTable_QueryVariables,
  response: ecommerce_ProductsTable_QueryResponse,
|};
*/


/*
query ecommerce_ProductsTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...ProductsTable_project
    id
  }
}

fragment ProductsTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        products(offset: 0, limit: 20, sourceUrl: {operator: AND, values: []}) {
          count
          edges {
            node {
              ...ProductsRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment ProductsRow_issue on Product {
  id
  source_url
  schema
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ecommerce_ProductsTable_Query",
  "id": null,
  "text": "query ecommerce_ProductsTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...ProductsTable_project\n    id\n  }\n}\n\nfragment ProductsTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        products(offset: 0, limit: 20, sourceUrl: {operator: AND, values: []}) {\n          count\n          edges {\n            node {\n              ...ProductsRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ProductsRow_issue on Product {\n  id\n  source_url\n  schema\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ecommerce_ProductsTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ProductsTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ecommerce_ProductsTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "products",
                        "storageKey": "products(limit:20,offset:0,sourceUrl:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          v2,
                          {
                            "kind": "Literal",
                            "name": "sourceUrl",
                            "value": {
                              "operator": "AND",
                              "values": []
                            },
                            "type": "TextFilters"
                          }
                        ],
                        "concreteType": "ProductConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "count",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ProductEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Product",
                                "plural": false,
                                "selections": [
                                  v3,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "schema",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v3
                    ]
                  }
                ]
              }
            ]
          },
          v3
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cc4506323357d55e8f67bfcdf533a668';
module.exports = node;
